module.exports = __webpack_public_path__ + "img/login_with_google.34de7ff0.png";